<template>
<div>
  <div>
    <el-button size="mini" type="primary" @click="setData">保存</el-button>
    <el-button size="mini" @click="setComponentId('FurnishList')">返回</el-button>
  </div>
  <div>
    <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
      <el-descriptions-item label="装修许可证">
        <el-descriptions size="mini" :label-style="{width: '100px'}" direction="vertical" :column="2" border>
          <el-descriptions-item label="模板下载">
            <el-link type="primary" style="min-width: 250px;" @click="dowQueRen">《装修许可证》下载</el-link>
          </el-descriptions-item>
          <el-descriptions-item label="文件上传">
            <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="装修许可证" />
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>

    </el-descriptions>
  </div>
</div>
</template>

<script>
import FitmentFileSubgroup from "./components/FitmentFileSubgroup";
import FlowHttp from "../../common/FlowHttp";
import Http from "../../common/Http";

export default {
  name: "FurnishAdmission",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{

    }
  },
  activated() {
    this.getData()
  },
  mounted() {
    this.getData()
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.setProcessState(ret.data.ProcessState);
          try {
            if(ret.data.CheckHouseIntegrityBody){
              ret.data.CheckHouseIntegrityBody=JSON.parse(ret.data.CheckHouseIntegrityBody)
            }else {
              ret.data.CheckHouseIntegrityBody=[];
            }

          }catch (e) {
            ret.data.CheckHouseIntegrityBody=[];
          }

          that.form=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    dowQueRen(){
      if(!this.mainObj.house_id){
        this.$Message.error('点击左边树选择项目!');
        return false;
      }
      const that = this;
      ERP.showLoading()
      FlowHttp.post('house/HouseFurnish/getFurnishLicence',{house_id:that.mainObj.house_id,id:that.mainObj.id},ret=>{
        ERP.hideLoading()
        if(ret.code){
          window.open(FlowHttp.getBaseURL() +ret.data)
        }
      })
    },
    uploadFile(file_key){
      const that=this;
      Http.uploadFile(ret=>{
        that.form[file_key]=ret.path
        that.setData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/FurnishAdmission.vue